import { render, staticRenderFns } from "./FiltersContainer.vue?vue&type=template&id=95ff924a&scoped=true"
import script from "./FiltersContainer.vue?vue&type=script&lang=ts"
export * from "./FiltersContainer.vue?vue&type=script&lang=ts"
import style0 from "./FiltersContainer.vue?vue&type=style&index=0&id=95ff924a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ff924a",
  null
  
)

export default component.exports